module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SimcardAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/routes/add/index.js